import React from "react";

import { observer } from "mobx-react";

import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import { TournamentItems } from "..";

import { CategoryItemButton } from ".";

export const CategoryItem = observer(function CategoryItem(props: {
	sport: PrematchOfferMenuStore["menu"];
	category: PrematchOfferMenuStore["menu"];
	store: Parameters<typeof CategoryItemButton>[0]["store"] &
		Parameters<typeof TournamentItems>[0]["store"];
}) {
	return (
		<li className="nav--tertiary__item">
			<CategoryItemButton category={props.category} store={props.store} />
			<TournamentItems
				category={props.category}
				sport={props.sport}
				store={props.store}
			/>
		</li>
	);
});
